var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOngoingSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ongoing Support Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 20,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 12 V20 M32 44 V52 M52 32 H44 M20 32 H12",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 44 L16 48",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 44 L48 48",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 48 L48 48",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 48,
    r: 2,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOngoingSupportIcon);
export default __webpack_public_path__ + "static/media/ongoing-support-icon.9ae7cdb48ffa2149bb0ba031fd4e5949.svg";
export { ForwardRef as ReactComponent };